// Replace with your Firebase config
export const firebaseConfig = {
  apiKey: "AIzaSyBOaKibf_V0Q_eFJezbzuq9P4hKRv4iL-w",
  authDomain: "jenn-labonte.firebaseapp.com",
  databaseURL: "https://jenn-labonte-default-rtdb.firebaseio.com",
  projectId: "jenn-labonte",
  storageBucket: "jenn-labonte.appspot.com",
  messagingSenderId: "670366165390",
  appId: "1:670366165390:web:fb97030b55be2c2dd49cdf",
  measurementId: "G-SH03VQG4M5"
};



export const firebaseConfigSandbox = {
  apiKey: "AIzaSyD1-TnN-NPQpIcJftFYQlzYQqZ5PM1C-M8",
  authDomain: "jenn-labonte-sandbox.firebaseapp.com",
  databaseURL: "https://jenn-labonte-sandbox-default-rtdb.firebaseio.com",
  projectId: "jenn-labonte-sandbox",
  storageBucket: "jenn-labonte-sandbox.appspot.com",
  messagingSenderId: "839792733056",
  appId: "1:839792733056:web:ac4fc03198ca4e614c6f65",
  measurementId: "G-YH7G4CWVST"
};